(() => {
  const init = (root) => {
    root.querySelectorAll('[data-rack-all-products-sort]').forEach((form) => {
      if (form.dataset.ready) return;
      const select = form.querySelector('[name="sort_by"]');
      if (!select) return;
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.set('view', 'all-products');
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      });
      form.dataset.ready = 'true';
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
